import { Key_getInstance20c05dl0yuxib as Key_getInstance } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineDispatcher.mjs';
import {
  CoroutineStart_DEFAULT_getInstance3qi77grrvmsn3 as CoroutineStart_DEFAULT_getInstance,
  CoroutineStart_UNDISPATCHED_getInstance36t7e2kqqnuqp as CoroutineStart_UNDISPATCHED_getInstance,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineStart.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  _ReactiveState___init__impl__fvdp9b3rxdz1mjh763m as _ReactiveState___init__impl__fvdp9b,
  Companion_getInstance3byfqsk8b0ql6 as Companion_getInstance,
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
} from '../core/ReactiveState.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ReactiveLoadings35224pps2d9 as ReactiveLoading } from './ReactiveContext.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DependencyChangeListener1518w8dt8yuu7 as DependencyChangeListener } from './DependencyChangeListener.mjs';
import { RawReactive253xb355brtjj as RawReactive } from '../core/signals.mjs';
import { Job13y4jkazwjho0 as Job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  onRemove3k528udkni1ni as onRemove,
  Key_instancedbf5f19vpr99 as Key_instance,
} from './CalculationContext.mjs';
import { Reactive1jy75v4li6ldv as Reactive } from '../core/coreInterfaces.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function launchWithStart($this, $receiver, block) {
  var tmp;
  var tmp0_safe_receiver = $receiver.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_getInstance());
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.isDispatchNeeded_ft82v4_k$($receiver.get_coroutineContext_115oqo_k$())) === false) {
    tmp = CoroutineStart_UNDISPATCHED_getInstance();
  } else {
    tmp = CoroutineStart_DEFAULT_getInstance();
  }
  var tmp_0 = tmp;
  return launch($receiver, VOID, tmp_0, ReactiveContextSuspending$launchWithStart$slambda(block));
}
function ReactiveContextSuspending$launchWithStart$slambda($block) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    yield* $($block($completion), $completion);
    return Unit_instance;
  }), 1);
}
function ReactiveContextSuspending$startCalculation$slambda(this$0, $done) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.core.reactiveState' call
    var tmp;
    try {
      var tmp$ret$1 = yield* $(this$0.action_1(this$0, $completion), $completion);
      tmp = _ReactiveState___init__impl__fvdp9b(tmp$ret$1);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof CancellationException()) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof ReactiveLoading()) {
          var _unused_var__etf5q3 = $p;
          tmp_0 = Companion_getInstance().notReady_1;
        } else {
          if ($p instanceof Exception()) {
            var e_0 = $p;
            tmp_0 = Companion_getInstance().exception_iibuh2_k$(e_0);
          } else {
            throw $p;
          }
        }
      }
      tmp = tmp_0;
    }
    var result = tmp;
    var tmp_1;
    var tmp_2;
    if (!this$0.useLastWhileLoading_1) {
      tmp_2 = true;
    } else {
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
      var tmp_3;
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
      if (!equals(_ReactiveState___get_raw__impl__92ipya(result), InternalReactiveNotActive_instance)) {
        tmp_3 = !equals(_ReactiveState___get_raw__impl__92ipya(result), InternalReactiveNotReady_instance);
      } else {
        tmp_3 = false;
      }
      tmp_2 = tmp_3;
    }
    if (tmp_2) {
      this$0.reportTo_1.set_state_wnfcx0_k$(result);
      tmp_1 = Unit_instance;
    }
    this$0.dependencyBlockEnd_6wfk9j_k$();
    $done._v = true;
    return Unit_instance;
  }), 0);
}
var ReactiveContextSuspendingClass;
function ReactiveContextSuspending() {
  if (ReactiveContextSuspendingClass === VOID) {
    class $ extends DependencyChangeListener() {
      constructor(scope, useLastWhileLoading, reportTo, action) {
        useLastWhileLoading = useLastWhileLoading === VOID ? false : useLastWhileLoading;
        reportTo = reportTo === VOID ? RawReactive().new_com_lightningkite_reactive_core_RawReactive_4h91ij_k$() : reportTo;
        super();
        this.scope_1 = scope;
        this.useLastWhileLoading_1 = useLastWhileLoading;
        this.reportTo_1 = reportTo;
        this.action_1 = action;
        this.lastLoopJob_1 = null;
        this.active_1 = false;
        this.job_1 = Job();
        onRemove(this.scope_1, () => {
          this.cancel_2l89ey_k$();
          return Unit_instance;
        });
      }
      get_coroutineContext_115oqo_k$() {
        return this.scope_1.get_coroutineContext_115oqo_k$().plus_s13ygv_k$(this.job_1).plus_s13ygv_k$(this);
      }
      startCalculation_tphsqx_k$() {
        this.active_1 = true;
        var tmp0_safe_receiver = this.lastLoopJob_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.cancel$default_8haxne_k$();
        }
        this.job_1.cancel$default_8haxne_k$();
        this.job_1 = Job();
        this.dependencyBlockStart_qxo3ow_k$();
        var tmp = this;
        // Inline function 'kotlin.let' call
        var tmp$ret$1;
        $l$block_0: {
          var done = {_v: false};
          var job = launchWithStart(this, this, ReactiveContextSuspending$startCalculation$slambda(this, done));
          if (done._v) {
            tmp$ret$1 = null;
            break $l$block_0;
          } else {
            if (!this.useLastWhileLoading_1) {
              this.reportTo_1.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
            }
            tmp$ret$1 = job;
            break $l$block_0;
          }
        }
        tmp.lastLoopJob_1 = tmp$ret$1;
      }
      onDependencyChange_yaqozu_k$() {
        this.startCalculation_tphsqx_k$();
      }
      onDependencyNotReady_ntxysq_k$() {
        if (!this.useLastWhileLoading_1) {
          this.reportTo_1.set_state_wnfcx0_k$(Companion_getInstance().notReady_1);
        }
      }
      cancel_2l89ey_k$() {
        super.cancel_2l89ey_k$();
        this.job_1.cancel$default_8haxne_k$();
        this.job_1 = Job();
        this.active_1 = false;
        var tmp0_safe_receiver = this.lastLoopJob_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.lastLoopJob_1 = null;
          tmp0_safe_receiver.cancel$default_8haxne_k$();
        }
      }
      get_state_wc71uu_k$() {
        return this.reportTo_1.get_state_wc71uu_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.reportTo_1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.reportTo_1.beginUse_omrbby_k$();
      }
    }
    initMetadataForClass($, 'ReactiveContextSuspending', VOID, VOID, [Reactive()]);
    ReactiveContextSuspendingClass = $;
  }
  return ReactiveContextSuspendingClass;
}
function reactiveSuspending(_this__u8e3s4, action) {
  // Inline function 'kotlin.also' call
  var this_0 = new (ReactiveContextSuspending())(_this__u8e3s4, VOID, VOID, action);
  this_0.startCalculation_tphsqx_k$();
  var tmp0_safe_receiver = _this__u8e3s4.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else
    tmp0_safe_receiver.watchBackgroundProcess_1utgjt_k$(this_0);
  return this_0;
}
//region block: exports
export {
  ReactiveContextSuspending as ReactiveContextSuspending39biijty1bpc5,
  reactiveSuspending as reactiveSuspendingtu9o1tcdi36e,
};
//endregion

//# sourceMappingURL=ReactiveContextSuspending.mjs.map
